var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocked = function SvgLocked(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 22",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414a5f",
    d: "M14.916 9.079h-1.035v-3.18a5.881 5.881 0 1 0-11.762 0v3.18H1.084A1.07 1.07 0 0 0 0 10.167v10.744a1.086 1.086 0 0 0 1.084 1.088h13.832A1.1 1.1 0 0 0 16 20.911V10.167a1.086 1.086 0 0 0-1.084-1.088M4.287 5.899a3.713 3.713 0 1 1 7.425-.165v3.3H4.287Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocked);
export default ForwardRef;